import { type FC, type ReactNode } from "react";
import { box } from "./styles.css";

type Props = {
  children: ReactNode;
  className?: string;
};

export const InformationBox: FC<Props> = ({ children, className }) => (
  <div className={`${box} ${className || ""}`}>{children}</div>
);
